import React from 'react';

import { FolderOpenOutlined } from '@ant-design/icons';
import { Flex, Tag } from 'antd';
import upperFirst from 'lodash/upperFirst';

import BlockedIcon from '@/components/icons/BlockedIcon';
import PendingV2Icon from '@/components/icons/PendingV2Icon';
import ValidatedIcon from '@/components/icons/Validated';
import { usePartnerClosureRequest } from '@/features/gdpr/partnerClosure/api/getPartnerClosureRequest';
import { ClosureRequestCountdown } from '@/features/gdpr/partnerClosure/components/ClosureRequestStatusCountdown';
import { ClosureRequestStatusTag } from '@/features/gdpr/partnerClosure/components/ClosureRequestStatusTag';

const STATUS_ICON: Record<string, React.ReactNode> = {
  VALIDATED: <ValidatedIcon />,
  PENDING: <PendingV2Icon />,
  BLOCKED: <BlockedIcon />,
};

interface IChildStatusCellProps {
  partnerId: string;
  status: string;
  archived: boolean;
}

export const ChildStatusCell = ({
  partnerId,
  status,
  archived,
}: IChildStatusCellProps) => {
  const { data: closureRequest } = usePartnerClosureRequest({ partnerId });

  return (
    <Flex vertical gap="0.2rem">
      <Flex gap="0.2rem" align="center">
        {STATUS_ICON[status]}
        {upperFirst(status.toLowerCase())}
      </Flex>
      {archived && (
        <Tag icon={<FolderOpenOutlined />} color="red">
          Archived
        </Tag>
      )}
      <ClosureRequestStatusTag closureRequest={closureRequest} />
      <ClosureRequestCountdown closureRequest={closureRequest} />
    </Flex>
  );
};
